import "./outhesited.scss";
import title from "./assets/title.png";
import er from "./assets/er.png";
import imp from "./assets/imp.png";
import pv from "./assets/pv.png";
import gif from "./assets/outheisted.gif";
import tweets1 from "./assets/tweets1.png";
import tweets2 from "./assets/tweets2.png";
import tweets3 from "./assets/tweets3.png";
import users from "./assets/users.png";
import { motion } from "framer-motion";
import { fade, childFade } from "../fade.js";

const Outheisted = () => {
  return (
    <section class="section outheisted">
      <motion.div
        className="text"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <img src={title} alt="Out-heisting the fans" className="title" />
        <p>
          Fans would try to find illegal ways to watch it, so we created our own
          illegal streaming site with all the episodes. However, after the first
          two minutes of the first episode, we interrupted them with a message
          from the gang that the only way to watch it was on Netflix. We even
          created spambots to spread the word of this site.
        </p>
        <motion.a
          href="https://seriesforall.com"
          target="_blank"
          className="btn"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.88 }}
        >
          Experience the prank
        </motion.a>
      </motion.div>
      <motion.img
        className="gif"
        src={gif}
        alt="Gif of demo"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      />
      <motion.div
        className="results"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <img
          src={imp}
          alt="impressions"
          className="imp"
          variants={childFade}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
          key="imp"
        />
        <img
          src={er}
          alt="engagement rate"
          className="er"
          variants={childFade}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
          key="er"
        />
        <img
          src={users}
          alt="users"
          className="users"
          variants={childFade}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
          key="users"
        />
        <img
          src={pv}
          alt="page views"
          className="pv"
          variants={childFade}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
          key="pv"
        />
      </motion.div>
      <motion.div
        className="tweets"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
        key="tweets"
      >
        <div className="left">
          <img src={tweets1} alt="tweets" />
        </div>
        <div className="right">
          <img src={tweets2} alt="tweets" />
          <img src={tweets3} alt="tweets" />
        </div>
        <p className="disclaimer">Translated for context</p>
      </motion.div>
    </section>
  );
};

export default Outheisted;
